export type PaymentTier = "free" | "basic" | "premium" | "platinum";

const TIER_ORDER: Record<PaymentTier, number> = {
  free: 0,
  basic: 1,
  premium: 2,
  platinum: 3,
};

export function hasMinTier(tier: PaymentTier | null, minTier: PaymentTier): boolean {
  if (!tier) return false;
  return TIER_ORDER[tier] >= TIER_ORDER[minTier];
}
